import { actions as shopActions } from '~/sites/shop/store/category'
import gql from 'graphql-tag'
import isEqual from 'lodash/isEqual'

export * from '~/sites/shop/store/category'

export const actions = {
  ...shopActions,
  // CVB CMS filtered_category only supports title and filter references, not catalog content fields.
  async LOAD_CANONICAL_CATEGORIES(_context, { catalogState, categoryStore }) {
    try {
      const selectedParameters = catalogState.parameters.filter(parameter => parameter.isSelected)
      if (categoryStore && selectedParameters.length > 0) {
        const selectedParametersIds = selectedParameters.map(parameter => parameter.id)
        const selectedValuesIds = selectedParameters
          .reduce((acc, parameter) => [...acc, ...parameter.values.filter(value => value.isSelected)], [])
          .map(value => value.id)

        let client = this.app.apolloProvider.defaultClient
        const result = await client.query({
          query: gql`
            query($parameterIds: [String], $valueIds: [String], $storeCategoryId: String) {
              filtered_category(
                filters: {
                  sliced_categories: { entity_id: [$storeCategoryId] }
                  parameters: { entity_id: $parameterIds, values: $valueIds }
                }
              ) {
                entities {
                  parameters {
                    entityId
                    values
                  }
                  title
                }
              }
              virtual_category(
                filters: {
                  sliced_categories: { entity_id: [$storeCategoryId] }
                  parameters: { entity_id: $parameterIds, values: $valueIds }
                }
              ) {
                entities {
                  title
                  sliced_categories {
                    entityId
                  }
                  page_meta {
                    slug
                  }
                  parameters {
                    entityId
                    values
                  }
                }
              }
            }
          `,
          variables: {
            parameterIds: selectedParametersIds,
            valueIds: selectedValuesIds,
            storeCategoryId: String(categoryStore.id),
          },
        })
        const filteredCategory = result.data.filtered_category.entities.find(filteredCategory => {
          const filteredCategoryParameterIds = filteredCategory.parameters.map(parameter => parameter.entityId)
          const filteredCategoryValuesIds = filteredCategory.parameters.reduce(
            (acc, parameter) => [...acc, ...parameter.values],
            [],
          )
          return (
            isEqual(selectedParametersIds.sort(), filteredCategoryParameterIds.sort()) &&
            isEqual(selectedValuesIds.sort(), filteredCategoryValuesIds.sort())
          )
        })
        return {
          canonicalVirtualCategory: result.data.virtual_category.entities.find(virtualCategory => {
            const virtualCategorySlicedCategories = virtualCategory.sliced_categories.map(category =>
              Number(category.entityId),
            )
            const virtualCategoryParameterIds = virtualCategory.parameters.map(parameter => parameter.entityId)
            const virtualCategoryValuesIds = virtualCategory.parameters.reduce(
              (acc, parameter) => [...acc, ...parameter.values],
              [],
            )
            return (
              virtualCategorySlicedCategories.length === 1 &&
              virtualCategorySlicedCategories[0] === categoryStore.id &&
              isEqual(selectedParametersIds.sort(), virtualCategoryParameterIds.sort()) &&
              isEqual(selectedValuesIds.sort(), virtualCategoryValuesIds.sort())
            )
          }),
          filteredCategory,
        }
      }
    } catch (e) {
      console.error(e)
    }
  },
}
